import { z } from 'zod';
import { cuidSchema, emailSchema, isoDateSchema } from './common.js';
/** Customer booking contracts (docs/10 "/public"). */
export const tripSearchSchema = z.object({
    from: cuidSchema,
    to: cuidSchema,
    date: isoDateSchema,
    passengers: z.coerce.number().int().min(1).max(20).default(1),
});
export const seatCodeSchema = z
    .string()
    .trim()
    .min(1)
    .max(8)
    .regex(/^[A-Z]{1,3}[0-9]{1,3}$/i, 'That is not a seat number');
export const createHoldSchema = z.object({ seatCode: seatCodeSchema });
export const seatMapQuerySchema = z.object({ fromStopId: cuidSchema, toStopId: cuidSchema });
export const passengerSchema = z.object({
    seatCode: seatCodeSchema,
    passengerName: z.string().trim().min(1).max(120),
});
export const createBookingSchema = z.object({
    tripId: cuidSchema,
    fromStopId: cuidSchema,
    toStopId: cuidSchema,
    seats: z.array(passengerSchema).min(1).max(20),
    contact: z.object({
        name: z.string().trim().min(1).max(120),
        email: emailSchema,
        phone: z.string().trim().min(5).max(32).optional(),
    }),
    /**
     * A promotion code, if the passenger typed one (DECISIONS D70).
     *
     * What it is WORTH is never sent from here: the client says which code, and the server
     * works out the discount against the fare it is applying to. A client that could name its
     * own discount would be a client that could set its own price.
     */
    promotionCode: z.string().trim().max(24).optional().or(z.literal('')),
});
export const retrieveBookingSchema = z.object({
    reference: z.string().trim().min(3).max(20),
    email: emailSchema,
});
export const pushSubscribeSchema = z.object({
    endpoint: z.string().url().max(2000),
    keys: z.object({
        p256dh: z.string().min(1).max(500),
        auth: z.string().min(1).max(500),
    }),
});
// --- disputes ---------------------------------------------------------------
export const openDisputeSchema = z.object({
    type: z.enum(['REFUND_REQUEST', 'COMPLAINT', 'OTHER']),
    subject: z.string().trim().min(3).max(120),
    message: z.string().trim().min(3).max(4000),
});
export const disputeMessageSchema = z.object({
    body: z.string().trim().min(1).max(4000),
});
export const resolveDisputeSchema = z.object({
    action: z.enum(['REVIEW', 'REFUND', 'REJECT', 'CLOSE']),
    note: z.string().trim().max(1000).optional(),
});
//# sourceMappingURL=booking.js.map